import { ILectur } from 'constants/types/common.types'

interface ILectors {
  name: string
  img: string
}

interface ILectorsCircles {
  lectursIds: number[]
  borderColor: string
  dopLecturNames?: string
  dopLecturAmmount?: number
  wrapperModificator?: string
  isNamesBreaked?: boolean
}

const prepareLecturNames = (lectorsWithAvatars: ILectur[] | null, dopLecturs: string): string => {
  if (!lectorsWithAvatars) return ''

  return (
    [...lectorsWithAvatars]
      .map((lectur, index, array) => {
        let devider = ','

        if (dopLecturs) {
          devider = ','
        } else if (index === array.length - 1) {
          devider = '.'
        }

        const { firstName, secondName, lastName } = lectur
        const fullName = `${lastName} ${firstName?.[0]}.${(secondName?.[0] || '') + devider} `
        return fullName
      })
      .join(' ') + dopLecturs
  )
}

export type { ILectorsCircles, ILectors }
export { prepareLecturNames }
